import React, { useState, useEffect } from "react";
import allApi from "../../../api/allApi";
import EdgeUserPopUp from "../common/EdgeUserPopup";
import closeIcon from "../../../assets/images/close.svg";
import errorIcon from "../../../assets/images/error-2.png";
import EditEdgePopup from "../common/EditEdgePopup";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Loader from "../common/Loader";
import InputMask from "react-input-mask";
import { useLocation } from "react-router-dom";
import successIcon from "../../../assets/images/success_lg.png";
import { useLocalization } from "../localization/LocalizationContext.js";
import NmsTableSearch, { searchRows } from "../common/NmsTableSearch";

function EdgeManagement() {
  const location = useLocation();
  const { localizationStrings } = useLocalization();
  const [activeTab, setActiveTab] = useState("gateways");
  const [gateways, setGateways] = useState([]);
  const [gatewaysPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showEdgeUserPopUp, setShowEdgeUserPopUp] = useState(false);
  const [error, setError] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showEditSuccess, setShowEditSuccess] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState([]);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [gateway_id, setGateway_id] = useState("");
  const [deleteModel, setDeleteModel] = useState(false);
  const [gateId, setGateId] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [filteredGateways, setFilteredGateways] = useState([]);
  const [originalGateways, setOriginalGateways] = useState([]);
  const [individualCheckboxChecked, setIndividualCheckboxChecked] = useState(
    {}
  );
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [gatewayToDelete, setGatewayToDelete] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [showEmailConfirmationModal, setShowEmailConfirmationModal] =
    useState(false);
  const [searchQueries, setSearchQueries] = useState({
    gateway_name: "",
    organisation_name: "",
    site_name: "",
    publisher_topic: "",
    subscriber_topic: "",
    username: "",
    agent_mail: "",
    status: "",
  });
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [tableQuery, setTableQuery] = useState("");

  // ---- HTTP (EDGE Gateway) tab state ----
  const [edgeGateway, setEdgeGateway] = useState({
    name: "VVDN_edge",
    serialNo: "",
    macAddress: "",
    ipAddress: "192.168.10.10",
  });
  const [managedDevices, setManagedDevices] = useState([]);
  const [showManagedDeviceForm, setShowManagedDeviceForm] = useState(false);
  const [managedDevice, setManagedDevice] = useState({
    name: "",
    ipAddress: "",
    macAddress: "",
    serialNo: "",
    deviceType: "",
    communicationProtocol: [],
  });

  const [sortOrder, setSortOrder] = useState({
    gateway_name: "asc",
    organisation_name: "asc",
    site_name: "asc",
    publisher_topic: "asc",
    subscriber_topic: "asc",
    username: "asc",
    agent_mail: "asc",
    status: "asc",
  });

  const handleEditSuccess = () => {
    setShowEditSuccess(true);
    setTimeout(() => setShowEditSuccess(false), 3000);
  };

  const handleSuccess = () => {
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 3000);
  };

  // ---- HTTP (EDGE Gateway) tab handlers ----
  const handleManagedDeviceChange = (e) => {
    const { name, value } = e.target;

    setManagedDevice((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleProtocolChange = (protocol) => {
    setManagedDevice((prev) => {
      const exists = prev.communicationProtocol.includes(protocol);

      return {
        ...prev,
        communicationProtocol: exists
          ? prev.communicationProtocol.filter((item) => item !== protocol)
          : [...prev.communicationProtocol, protocol],
      };
    });
  };

  const addManagedDevice = () => {
    if (
      !managedDevice.name ||
      !managedDevice.ipAddress ||
      !managedDevice.macAddress ||
      !managedDevice.deviceType ||
      managedDevice.communicationProtocol.length === 0
    ) {
      return;
    }

    setManagedDevices((prev) => [
      ...prev,
      {
        ...managedDevice,
        id: Date.now(),
      },
    ]);

    setManagedDevice({
      name: "",
      ipAddress: "",
      macAddress: "",
      serialNo: "",
      deviceType: "",
      communicationProtocol: [],
    });

    setShowManagedDeviceForm(false);
  };

  useEffect(() => {
    getEdgeDevices();
  }, []);

  useEffect(() => {
    if (location.state && location.state.statusResponse) {
      const statusList = location.state.statusResponse.map(
        (item) => item.status
      );
      setStatusFilter(statusList);
    } else {
      setStatusFilter(null);
    }
  }, [location.state]);

  useEffect(() => {
    let next = originalGateways.length ? originalGateways : gateways;
    if (statusFilter && statusFilter.length) {
      next = next.filter((gateway) =>
        statusFilter.some(
          (status) =>
            String(gateway.status || "").toUpperCase() === String(status).toUpperCase()
        )
      );
    }
    setFilteredGateways(
      searchRows(next, tableQuery, [
        "gateway_name",
        "organisation_name",
        "site_name",
        "publisher_topic",
        "subscriber_topic",
        "username",
        "agent_mail",
        "status",
      ])
    );
  }, [gateways, originalGateways, statusFilter, tableQuery]);

  async function getEdgeDevices() {
    setLoading(true);
    setRefreshing(true);
    try {
      const api = new allApi();
      let response = await api.getRequest("api/gateway/all");
      if (response && Array.isArray(response)) {
        response.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setGateways(response);
        setOriginalGateways(response);
      }
    } catch (error) {
      setError("Error fetching gateways");
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }

  const handleAddButtonClick = () => {
    setShowEdgeUserPopUp(true);
  };

  const handleEdgeClose = () => {
    setShowEdgeUserPopUp(false);
  };

  const handleSaveEdge = async () => {
    try {
      setShowEdgeUserPopUp(true);
    } catch (error) {
      console.error("Error adding discovered device:", error);
      setError("Error adding discovered device");
    }
  };

  const handleDeleteGateway = async (gatewayIds = selectedRows) => {
    try {
      const api = new allApi();

      if (!gatewayIds || gatewayIds.length === 0) {
        setError("No gateways selected for deletion.");
        setShowErrorPopup(true);
        return;
      }

      if (!Array.isArray(gatewayIds)) {
        gatewayIds = [gatewayIds];
      }

      const payload = { gateway_id: gatewayIds };

      const response = await api.deleteRequest(
        "api/gateway/delete?isConfirmed=false",
        payload
      );

      if (response.ok) {
        // If 200 OK
        setShowSuccessModal(true);
        getEdgeDevices();
        setSelectedRows([]);
      } else if (response.status === 409) {
        // If 409 Conflict or 500 Server Error
        const resData = await response.json();
        setGatewayToDelete(gatewayIds);
        setError(
          resData?.message ||
          "This gateway is linked to devices. Do you want to force delete?"
        );
        setShowErrorPopup(true);
      } else if (response.status === 500) {
        // 500 Server Error
        const resData = await response.json();
        setError(
          resData?.message ||
          "An unexpected server error occurred. Please try again."
        );
        setShowErrorPopup(true);
      } else {
        // Other errors
        const resData = await response.json();
        setError(
          resData?.message || "An unexpected error occurred. Please try again."
        );
        setShowErrorPopup(true);
      }
    } catch (error) {
      console.error("Delete Error:", error);
      setError("An unexpected error occurred. Please try again.");
      setShowErrorPopup(true);
    } finally {
      setDeleteModel(false);
    }
  };

  const handleConfirmedDelete = async () => {
    try {
      const api = new allApi();
      const payload = { gateway_id: gatewayToDelete };

      const response = await api.deleteRequest(
        "api/gateway/delete?isConfirmed=true",
        payload
      );

      if (response.ok) {
        setShowSuccessModal(true);
        getEdgeDevices();
        setGatewayToDelete(null);
        setSelectedRows([]);
      } else {
        const resData = await response.json();
        setError(
          resData?.message || "An unexpected error occurred. Please try again."
        );
        setShowErrorPopup(true);
      }
    } catch (error) {
      console.error("Error confirming deletion:", error);
      setError("An unexpected error occurred. Please try again.");
      setShowErrorPopup(true);
    }
  };

  const handleCloseErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const sendEmail = async (requestID) => {
    try {
      const api = new allApi();
      const payload = { request_id: requestID };
      const response = await api.postRequest(
        `api/gateway/config_file`,
        "",
        payload
      );

      if (response && response.status === 200) {
        setShowSuccessModal(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setShowFailurePopup(true);
      }
    }
  };

  const handleEditGateway = async (gatewayId) => {
    try {
      const gatewayData = await fetchGatewayById(gatewayId);
      setSelectedGateway(gatewayData);
      setShowEditPopup(true);
    } catch (error) {
      setError("Error fetching gateway data for editing");
    }
  };

  const handleSelectAllCheckbox = () => {
    setSelectAllChecked((prev) => !prev);
    const newCheckboxState = {};
    const newSelectedRows = [];

    filteredGateways.forEach((gateway) => {
      newCheckboxState[gateway.request_id] = !selectAllChecked;

      if (!selectAllChecked) {
        newSelectedRows.push(gateway.request_id);
      }
    });

    setIndividualCheckboxChecked(newCheckboxState);
    setSelectedRows(!selectAllChecked ? newSelectedRows : []); // Update selectedRows
  };

  const handleIndividualCheckboxChange = (gateway) => {
    console.log("Gateway:", gateway);

    setIndividualCheckboxChecked((prev) => ({
      ...prev,
      [gateway.request_id]: !prev[gateway.request_id],
    }));

    setSelectedRows((prev) => {
      if (prev.includes(gateway.request_id)) {
        // Remove gateway if unchecked
        return prev.filter((id) => id !== gateway.request_id);
      } else {
        // Add gateway if checked
        return [...prev, gateway.request_id];
      }
    });
  };

  const fetchGatewayById = async (gatewayId) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/gateway/${gatewayId}`);
      return response;
    } catch (error) {
      console.error("Error fetching gateway by ID:", error);
      throw new Error("Error fetching gateway by ID");
    }
  };

  const handleSearchChange = (e, fieldName) => {
    const { value } = e.target;

    setSearchQueries((prev) => ({
      ...prev,
      [fieldName]: value,
    }));

    if (value.trim() === "") {
      // Reset to the original data if the input is cleared
      setGateways(originalGateways);
    } else {
      // Filter the original data based on the current field name
      const filtered = originalGateways.filter((gateway) =>
        gateway[fieldName]
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase())
      );
      setGateways(filtered);
    }
    setCurrentPage(1);
    // Update search query state for controlled input fields
  };

  const handleSortChange = (field) => {
    const newOrder = sortOrder[field] === "asc" ? "desc" : "asc";
    const sortedGateways = [...filteredGateways].sort((a, b) => {
      const aValue = a[field] ? a[field].toString().toLowerCase() : "";
      const bValue = b[field] ? b[field].toString().toLowerCase() : "";

      if (newOrder === "asc") {
        return aValue.localeCompare(bValue);
      } else {
        return bValue.localeCompare(aValue);
      }
    });

    setFilteredGateways(sortedGateways);
    setSortOrder((prevState) => ({
      ...prevState,
      [field]: newOrder, // Set the new sort order for the field
    }));
  };

  // const filteredGateways = gateways.filter((gateway) => {
  //   return Object.keys(searchQueries).every((key) => {
  //     const queryValue = searchQueries[key]?.toLowerCase();
  //     const gatewayValue = gateway[key]?.toString().toLowerCase();

  //     if (!queryValue) {
  //       return true;
  //     }
  //     if (key === 'status') {
  //       return gatewayValue === queryValue;
  //     }
  //     return gatewayValue.includes(queryValue);
  //   });
  // });

  const indexOfLastGateway = currentPage * gatewaysPerPage;
  const indexOfFirstGateway = indexOfLastGateway - gatewaysPerPage;
  const totalFilteredGateways = filteredGateways.length;
  const currentGateways = filteredGateways.slice(
    indexOfFirstGateway,
    indexOfLastGateway
  );

  const totalPages = Math.ceil(totalFilteredGateways / gatewaysPerPage);
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };
  const handlePageClick = (page) => {
    setCurrentPage(page);
  };
  const getPageNumbers = () => {
    const range = 1;
    const start = Math.max(1, currentPage - range);
    const end = Math.min(totalPages, currentPage + range);

    return [...Array(end - start + 1).keys()].map((i) => start + i);
  };

  const openDeleteModel = (gatewayIds) => {
    setDeleteModel(true);
    setGateId(gatewayIds);
  };

  return (
    <div>
      <div className="inc-card ch-100">
        <div className="inc-card-title">
          <ul className="nav nav-underline" id="edgeManagementTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "gateways" ? "active" : ""}`}
                id="gateways-tab"
                type="button"
                role="tab"
                aria-controls="gateways-tab-pane"
                aria-selected={activeTab === "gateways" ? "true" : "false"}
                onClick={() => setActiveTab("gateways")}
              >
                {localizationStrings?.snmpGateway}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "http" ? "active" : ""
                  }`}
                id="http-tab"
                type="button"
                role="tab"
                aria-controls="http-tab-pane"
                aria-selected={activeTab === "http" ? "true" : "false"}
                onClick={() => setActiveTab("http")}
              >
                {localizationStrings?.httpGateway}
              </button>
            </li>
          </ul>
          {activeTab === "gateways" && (
            <div className="inc-card-button">
              <NmsTableSearch
                value={tableQuery}
                onChange={setTableQuery}
                placeholder={localizationStrings?.search || "Search gateways"}
              />
              <button
                className="text-btn primary-btn"
                onClick={handleAddButtonClick}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                {localizationStrings?.add}
              </button>
              <button
                className="icon-btn"
                title="Refresh"
                onClick={() => getEdgeDevices()}
              >
                {refreshing ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                ) : (
                  <i className="fa fa-refresh" aria-hidden="true"></i>
                )}{" "}
              </button>
              <button
                className="icon-btn"
                title={selectedRows.length === 0 ? "" : "Delete Selected"}
                onClick={() => openDeleteModel()}
                disabled={selectedRows.length === 0}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          )}

          {activeTab === "http" && (
            <div className="inc-card-button">
              <button
                type="button"
                className="text-btn primary-btn"
                onClick={() => setShowManagedDeviceForm(true)}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                Manage Device
              </button>
            </div>
          )}
        </div>
        {activeTab === "gateways" && (
          <>
            <div>
              <EdgeUserPopUp
                showSuccessMessage={showSuccessMessage}
                handleSuccess={handleSuccess}
              />
              {showSuccessMessage && (
                <div className="alert alert-success">
                  <strong>Success!</strong> Edge User Created successfully.
                </div>
              )}
            </div>
            <div className="inc-card-body">
              <div className="inc-card-table">
                <table className="full-table m-head">
                  <thead>
                    <tr>
                      <th>
                        <label className="checkbox">
                          <input
                            type="checkbox"
                            checked={selectAllChecked}
                            onChange={() => handleSelectAllCheckbox()}
                          />
                          <span className="indicator"></span>
                        </label>
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("gateway_name")}
                      >
                        {localizationStrings?.gatewayName}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("organisation_name")}
                      >
                        {localizationStrings?.organisation}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("site_name")}
                      >
                        {localizationStrings?.siteName}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("publisher_topic")}
                      >
                        {localizationStrings?.publisherTopic}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("subscriber_topic")}
                      >
                        {localizationStrings?.subscriberTopic}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("username")}
                      >
                        {localizationStrings?.username}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("agent_mail")}
                      >
                        {localizationStrings?.agentEmail}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th
                        className="inc-th-sort"
                        onClick={() => handleSortChange("status")}
                      >
                        {localizationStrings?.status}
                        <i className="fa fa-sort" aria-hidden="true" />
                      </th>
                      <th>{localizationStrings?.action}</th>
                    </tr>
                    <tr className="search-border">
                      <td></td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="gateway_name"
                          value={searchQueries.gateway_name}
                          onChange={(e) => handleSearchChange(e, "gateway_name")}
                        />
                        <i
                          className={`fa ${sortOrder.gateway_name === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("gateway_name")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="organisation_name"
                          value={searchQueries.organisation_name}
                          onChange={(e) =>
                            handleSearchChange(e, "organisation_name")
                          }
                        />
                        <i
                          className={`fa ${sortOrder.organisation_name === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("organisation_name")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="site_name"
                          value={searchQueries.site_name}
                          onChange={(e) => handleSearchChange(e, "site_name")}
                          autoComplete="off"
                        />
                        <i
                          className={`fa ${sortOrder.site_name === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("site_name")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="publisher_topic"
                          value={searchQueries.publisher_topic}
                          onChange={(e) => handleSearchChange(e, "publisher_topic")}
                        />
                        <i
                          className={`fa ${sortOrder.publisher_topic === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("publisher_topic")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="subscriber_topic"
                          value={searchQueries.subscriber_topic}
                          onChange={(e) =>
                            handleSearchChange(e, "subscriber_topic")
                          }
                        />
                        <i
                          className={`fa ${sortOrder.subscriber_topic === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("subscriber_topic")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="username"
                          value={searchQueries.username}
                          onChange={(e) => handleSearchChange(e, "username")}
                        />
                        <i
                          className={`fa ${sortOrder.username === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("username")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="agent_mail"
                          value={searchQueries.agent_mail}
                          onChange={(e) => handleSearchChange(e, "agent_mail")}
                        />
                        <i
                          className={`fa ${sortOrder.agent_mail === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("agent_mail")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td>
                        <input
                          className="searchBox smallWidth"
                          type="text"
                          name="status"
                          value={searchQueries.status}
                          onChange={(e) => handleSearchChange(e, "status")}
                        />
                        <i
                          className={`fa ${sortOrder.status === "asc"
                            ? "fa fa-sort-amount-desc"
                            : "fa fa-sort-amount-asc"
                            }`}
                          onClick={() => handleSortChange("status")}
                          aria-hidden="true"
                        ></i>
                      </td>
                      <td colSpan="7"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="12">
                          <Loader />
                        </td>
                      </tr>
                    ) : (
                      currentGateways.map((gateway, index) => (
                        <tr key={index}>
                          <td>
                            <label className="checkbox">
                              <input
                                type="checkbox"
                                key={gateway.request_id}
                                checked={
                                  !!individualCheckboxChecked[gateway.request_id]
                                }
                                onChange={() =>
                                  handleIndividualCheckboxChange(gateway)
                                }
                              />{" "}
                              <span className="indicator"></span>
                            </label>
                          </td>
                          <td>{gateway.gateway_name}</td>
                          <td>{gateway.organisation_name}</td>
                          <td>{gateway.site_name}</td>
                          <td>{gateway.publisher_topic}</td>
                          <td>{gateway.subscriber_topic}</td>
                          <td>{gateway.username}</td>
                          <td>{gateway.agent_mail}</td>
                          <td>
                            <span
                              className={
                                "d-status " +
                                (gateway?.status === "Active"
                                  ? "online"
                                  : "offline")
                              }
                            >
                              {gateway.status}
                            </span>{" "}
                          </td>
                          <td>
                            <div className="button-group">
                              <button
                                title="Mail"
                                data-bs-toggle="modal"
                                data-bs-target="#mailConfirmation"
                                onClick={() => setRequestId(gateway.request_id)}
                              >
                                <i
                                  className="fa fa-envelope-o"
                                  aria-hidden="true"
                                ></i>{" "}
                              </button>
                              <button
                                title="Edit"
                                onClick={() =>
                                  handleEditGateway(gateway.request_id)
                                }
                              >
                                <i className="fa fa-pencil" aria-hidden="true"></i>
                              </button>
                              <button
                                className="icon-btn"
                                title="Delete"
                                data-bs-toggle="modal"
                                data-bs-target="#noDeviceDelete"
                                onClick={() => setRequestId(gateway.request_id)}
                              >
                                <i className="fa fa-trash" aria-hidden="true"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="pagination-container">
              {totalFilteredGateways > 0 ? (
                <>
                  <div className="pagination-info">
                    <p>
                      {localizationStrings?.showing} {indexOfFirstGateway + 1}-
                      {Math.min(
                        currentPage * gatewaysPerPage,
                        totalFilteredGateways
                      )}{" "}
                      {localizationStrings?.of} {totalFilteredGateways}{" "}
                      {localizationStrings?.records}
                    </p>
                  </div>
                  <div className="pagination">
                    <button onClick={handleFirstPage} disabled={currentPage === 1}>
                      {localizationStrings?.firstPage}
                    </button>
                    <button onClick={handlePrevPage} disabled={currentPage === 1}>
                      {localizationStrings?.previous}
                    </button>
                    {getPageNumbers().map((page) => (
                      <button
                        key={page}
                        onClick={() => handlePageClick(page)}
                        className={currentPage === page ? "active" : ""}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      {localizationStrings?.next}
                    </button>
                    <button
                      onClick={handleLastPage}
                      disabled={currentPage === totalPages}
                    >
                      {localizationStrings?.lastPage}
                    </button>
                  </div>
                </>
              ) : (
                <div>
                  <p>{localizationStrings?.noRecords}</p>
                </div>
              )}
            </div>
          </>
        )}

        {activeTab === "http" && (
          <div className="inc-card-body">
            <div className="discover-form">
              {/* ================= EDGE GATEWAY ================= */}
              <div className="inc-card mb-4">
                <div className="inc-card-title d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">EDGE Gateway</h5>
                </div>

                <div className="inc-card-body">
                  <div className="row">
                    {/* Name */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">
                        Name
                        <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        value={edgeGateway.name}
                        onChange={(e) =>
                          setEdgeGateway({
                            ...edgeGateway,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* Serial Number */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">
                        Serial No
                        <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        value={edgeGateway.serialNo}
                        onChange={(e) =>
                          setEdgeGateway({
                            ...edgeGateway,
                            serialNo: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* MAC */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">
                        MAC
                        <span className="text-danger">*</span>
                      </label>

                      <InputMask
                        autoComplete="off"
                        id="edgeGatewayMacAddress"
                        onChange={(e) =>
                          setEdgeGateway({
                            ...edgeGateway,
                            macAddress: e.target.value,
                          })
                        }
                        type="text"
                        mask="**:**:**:**:**:**"
                        placeholder="aa:bb:cc:dd:ee:ff"
                        data-type="mac"
                        className="form-control"
                        spellCheck="false"
                        formatChars={{
                          "*": "[0-9A-Fa-f]",
                        }}
                        value={edgeGateway.macAddress}
                      />
                    </div>

                    {/* IP */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">
                        IP
                        <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        value={edgeGateway.ipAddress}
                        onChange={(e) =>
                          setEdgeGateway({
                            ...edgeGateway,
                            ipAddress: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className="modal fade inc-alert"
        id="mailConfirmation"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog email-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <h3>{localizationStrings?.emailConfirmation}</h3>
              <p>
                {localizationStrings?.gatewayConfirmMsg} <br /> {localizationStrings?.gatewayMailHeading} <br />
                <div className="text-start mt-3">
                  {localizationStrings?.gatewayMailInfo1} <br />
                  {localizationStrings?.gatewayMailInfo2}
                  <br />
                  {localizationStrings?.gatewayMailInfo3}
                </div>
              </p>
              <div className="confirm-btn">
                <button
                  type="button"
                  className="btn btn-outline"
                  data-bs-dismiss="modal"
                >
                  {localizationStrings?.close}
                </button>
                <button
                  type="button"
                  className="btn btn-fill"
                  onClick={() => sendEmail(requestId)}
                  data-bs-dismiss="modal"
                >
                  {localizationStrings?.send}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade`}
        id="noDeviceDelete"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content inc-modal">
            <div className="modal-body success-msg">
              <h3>{localizationStrings?.deleteConfirmation1}</h3>
              <img src={errorIcon} alt="error" />
              <p>{localizationStrings?.deleteConfirmation}</p>
              <button
                className="text-btn primary-btn"
                data-bs-dismiss="modal"
                onClick={() => handleDeleteGateway(requestId)}
              >
                {localizationStrings?.yes}
              </button>
            </div>
          </div>
        </div>
      </div>
      {deleteModel && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <h3>{localizationStrings?.deleteConfirmation}</h3>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline"
                    onClick={() => setDeleteModel(false)}
                  >
                    {localizationStrings?.no}
                  </button>
                  <button
                    className="text-btn primary-btn"
                    onClick={() => handleDeleteGateway(gateId)}
                  >
                    {localizationStrings?.yes}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showFailurePopup && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <h3>{localizationStrings?.failToSendMail}.</h3>
                <div className="modal-footer">
                  <button className="text-btn primary-btn" onClick={() => setShowFailurePopup(false)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        show={showErrorPopup}
        onHide={handleCloseErrorPopup}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert"
      >
        <span className="success-icon">
          <img src={successIcon} alt="Success" />
        </span>
        <h4>{localizationStrings?.deleteStatus}</h4>
        <p>{localizationStrings?.gatewayDeletedSuccessfully}!</p>
        <Button
          onClick={() => {
            handleCloseErrorPopup();
            getEdgeDevices();
          }}
        >
          {localizationStrings?.ok}
        </Button>
      </Modal>
      {/* ================= MANAGE DEVICE MODAL ================= */}
      <Modal
        show={showManagedDeviceForm}
        onHide={() => setShowManagedDeviceForm(false)}
        centered
        size="lg"
        className="inc-alert"
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Device</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">

            {/* Name */}
            <div className="col-lg-6 mb-3">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="TPLINK"
                value={managedDevice.name}
                onChange={handleManagedDeviceChange}
              />
            </div>

            {/* IP */}
            <div className="col-lg-6 mb-3">
              <label className="form-label">
                IP <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                name="ipAddress"
                placeholder="192.168.10.20"
                value={managedDevice.ipAddress}
                onChange={handleManagedDeviceChange}
              />
            </div>

            {/* MAC */}
            <div className="col-lg-6 mb-3">
              <label className="form-label">
                MAC <span className="text-danger">*</span>
              </label>

              <InputMask
                autoComplete="off"
                id="managedDeviceMacAddress"
                name="macAddress"
                onChange={handleManagedDeviceChange}
                type="text"
                mask="**:**:**:**:**:**"
                placeholder="aa:bb:cc:dd:ee:ff"
                data-type="mac"
                className="form-control"
                spellCheck="false"
                formatChars={{
                  "*": "[0-9A-Fa-f]",
                }}
                value={managedDevice.macAddress}
              />
            </div>

            {/* Serial Number */}
            <div className="col-lg-6 mb-3">
              <label className="form-label">
                Serial No
              </label>

              <input
                type="text"
                className="form-control"
                name="serialNo"
                placeholder="Enter Serial Number"
                value={managedDevice.serialNo}
                onChange={handleManagedDeviceChange}
              />
            </div>

            {/* Device Type */}
            <div className="col-lg-6 mb-3">
              <label className="form-label">
                Device Type <span className="text-danger">*</span>
              </label>

              <select
                className="form-select"
                name="deviceType"
                value={managedDevice.deviceType}
                onChange={handleManagedDeviceChange}
              >
                <option value="">Select Device Type</option>
                <option value="AP">AP</option>
                <option value="Switch">Switch</option>
              </select>
            </div>

            {/* Communication Protocol */}
            <div className="col-lg-6 mb-3">
              <label className="form-label">
                Communication Protocol{" "}
                <span className="text-danger">*</span>
              </label>

              <div className="d-flex gap-3 mt-2">
                {["SNMP", "SSH", "RESTAPI"].map((protocol) => (
                  <label
                    key={protocol}
                    className="d-flex align-items-center gap-1"
                  >
                    <input
                      type="checkbox"
                      checked={managedDevice.communicationProtocol.includes(
                        protocol
                      )}
                      onChange={() => handleProtocolChange(protocol)}
                    />

                    <span>{protocol}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Existing Managed Devices */}
          {managedDevices.length > 0 && (
            <div className="mt-4">
              <h6 className="mb-3">Added Managed Devices</h6>

              <div className="inc-card-table">
                <table className="full-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Device Type</th>
                      <th>IP</th>
                      <th>MAC</th>
                      <th>Serial No</th>
                      <th>Protocol</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {managedDevices.map((device) => (
                      <tr key={device.id}>
                        <td>{device.name}</td>
                        <td>{device.deviceType}</td>
                        <td>{device.ipAddress}</td>
                        <td>{device.macAddress}</td>
                        <td>{device.serialNo || "-"}</td>
                        <td>
                          {device.communicationProtocol.join(", ")}
                        </td>

                        <td>
                          <div className="button-group">
                            <button
                              type="button"
                              title="Delete"
                              onClick={() =>
                                setManagedDevices((prev) =>
                                  prev.filter(
                                    (item) => item.id !== device.id
                                  )
                                )
                              }
                            >
                              <i
                                className="fa fa-trash"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="text-btn btn-outline"
            onClick={() => {
              setShowManagedDeviceForm(false);

              setManagedDevice({
                name: "",
                ipAddress: "",
                macAddress: "",
                serialNo: "",
                deviceType: "",
                communicationProtocol: [],
              });
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            className="text-btn primary-btn"
            onClick={addManagedDevice}
          >
            <i className="fa fa-plus" aria-hidden="true"></i>
            Add
          </button>
        </Modal.Footer>
      </Modal>

      <EditEdgePopup
        showPopUp={showEditPopup}
        handleClose={() => setShowEditPopup(false)}
        headerMessage1={localizationStrings?.editGateway}
        handleSuccess={handleEditSuccess}
        gateway={selectedGateway}
      />

      <EdgeUserPopUp
        showPopUp={showEdgeUserPopUp}
        handleClose={handleEdgeClose}
        headerMessage1={localizationStrings?.createEdgeLocation}
        handleSaveEdge={handleSaveEdge}
        handleSuccess={handleSuccess}
        closeIcon={closeIcon}
      />
    </div>
  );
}

export default EdgeManagement;